module.exports = __webpack_public_path__ + "img/tag.17434bfd.png";